<section class="container breadcrumb" *ngIf="!!breadcrumb" [ngClass]="{'breadcrumb--light': lightMode}">
  <div class="breadcrumb__item" *ngFor="let crumb of breadcrumb">
    <a [routerLink]="crumb.slug" class="breadcrumb__link">
      {{ crumb.title }}
    </a>
  </div>
</section>
